module.exports = __webpack_public_path__ + "img/gh-43160-2.prt.415d3ad1.jpg";